<template>
  <DocumentView api-type="credit-notes" type="Note de crédit" />
</template>

<script>
import DocumentView from '@/components/Templates/DocumentView'

export default {
  components: {
    DocumentView,
  },
}
</script>
